module.exports = __webpack_public_path__ + "static/media/giscagiancana.9a3f93db.jpeg";